import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { toastr } from 'react-redux-toastr';

export const ADD_STATEMENT_REQUEST = 'ADD_STATEMENT_REQUEST';
export const ADD_STATEMENT_SUCCESS = 'ADD_STATEMENT_SUCCESS';
export const ADD_STATEMENT_FAILURE = 'ADD_STATEMENT_FAILURE';

function requestAddStatement() {
  return {
    type: ADD_STATEMENT_REQUEST,
    isAddingStatement: true
  };
}

function receiveAddStatement(addStatementResults) {
  return {
    type: ADD_STATEMENT_SUCCESS,
    isAddingStatement: false,
    addStatementResults
  };
}

function rejectAddStatement(addStatementResults) {
  return {
    type: ADD_STATEMENT_FAILURE,
    isAddingStatement: false,
    addStatementResults
  };
}

export function addWhdStatement(accountId, data, callbackIfNoImy) {
  const postData = {
    formId: data.formId,
    type: data.whdStatementType,
    noImyForm: data.noImyForm === true,
    imy: {
      statement: {
        accountId,
        id: data.whdStatement.file.id,
        fileName: data.whdStatement.file.fileName,
        category: data.whdStatement.file.category,
        type: data.whdStatement.file.type,
        file: data.whdStatement.file
      },
      statementType: data.whdStatementType,
      statementFormat: data.statementFormat
    }
  };

  return (dispatch) => {
    dispatch(requestAddStatement());

    const promise = () => ApiService
      .addWhdStatement(accountId, postData)
      .then((response) => {
        dispatch(receiveAddStatement(response.data));
        toastr.success('Success', 'Statement Uploaded successfully');
        if (postData.noImyForm === true && callbackIfNoImy) {
          callbackIfNoImy();
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectAddStatement, true));
        }
      });
    return promise();
  };
}
